import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-sync"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.sync()
    document.addEventListener("turbo:load", this.sync)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.sync)
  }

  sync = () => {
    const sort = new URLSearchParams(window.location.search).get("sort")
    if (sort && this.hasInputTarget) {
      this.inputTarget.value = sort
    }
  }
}
